/* eslint-disable no-shadow */
import React, { useState } from 'react';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import Lista from './Lista';

function ModuloLista() {
  const [loading, setLoading] = useState(false);
  return (
    <Container>
      <Footer />
      <Menu />
      <Lista loading={loading} setLoading={setLoading} />
    </Container>
  );
}

export default ModuloLista;
